import type { CSS } from '../../stitches.config';
import { type SpacingScale, isSpacingValue } from './sizes';

export type MaxWidthTypes = 'full' | 'screen' | SpacingScale | string;
export type MaxWidthProps = { maxWidth?: MaxWidthTypes };

export function maxWidthCSS(maxWidth?: MaxWidthTypes): CSS {
  if (maxWidth === 'full' || maxWidth === '100%') {
    return { maxWidth: '100%' };
  }

  if (maxWidth === 'screen') {
    return { maxWidth: '100vw' };
  }

  if (typeof maxWidth === 'number' && isSpacingValue(maxWidth)) {
    return { maxWidth: `$${maxWidth}` };
  }

  if (typeof maxWidth === 'string') {
    return { maxWidth };
  }

  return {};
}
